<template>
    <div :class="className" :style="{height:height, width:width}" ref="vwChart"></div>
</template>

<script>
    export default {
        name: "LineChart",
        data() {
            return {
                chart: null,
                lineOption: {
                type: Object
            }
            }
        },
        props: {
            className: {
                type: String,
                default: 'chartClass'
            },
            width: {
                type: String,
                default: '100%'
            },
            height: {
              type: String,
              default: '300px'
            },
            lineSeries: {
                type: Array
            }
        },
        methods: {
            drawLine() {
                console.log(this.lineSeries);
                this.chart = this.g_echarts.init(this.$refs.vwChart);
                // 初始化实例
                this.lineOption = {
                    title: { // [图标标题名称]
                        text: '本周销售表',
                        subtext: '2020年3月29日汇总',
                        left: 'center',
                        top: 10,
                    },
                    toolbox: { // [工具栏]
                        feature: {
                            saveAsImage: {},
                            dataView : {},
                            magicType : {type : ['stack']} // line,bar,stack,tiled
                        }
                    },
                    tooltip: {  // [触发悬浮提示]
                        trigger: 'axis' // 默认值 item. item(只显示该点数据);axis(显示该坐标轴列下全部数据) //formatter
                    },
                    legend: {   // [图例：图标标题解释说明]
                        x: 'left',
                        orient: 'vertical',
                        top: 60,
                        left: 10, // 'left/center/right'
                        borderWidth: 1,
                        padding: 5,
                        type : 'plain', // 默认plain. plain(简单普通样式);scroll(可滚动翻页，当图例数量较多时)
                        data: this.legends, // 和series的name一一对应。
                        textStyle:{
                            color:'#ffffff',
                        }
                    },
                    grid: { // [坐标系]
                        left: 130,
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {    // [X坐标]
                        type: 'category',
                        boundaryGap: false,
                        data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                    },
                    yAxis: {    // [Y坐标]
                        type: 'value'
                    },
                    series: this.lineSeries
                };

                this.chart.setOption(this.lineOption);
                window.addEventListener("resize", () => { this.chart.resize();});
            }
        },
        mounted() {
            this.drawLine();
        },
        watch: {
            //观察lineSeries的变化
            lineSeries: {
                handler(newVal, oldVal) {
                    if (this.chart) {
                        if (newVal) {
                            this.lineOption.series = newVal;
                        } else {
                            this.lineOption.series = oldVal;
                        }
                        this.chart.setOption(this.lineOption);
                    } else {
//                        this.init();
                    }
                },

                deep: true //对象内部属性的监听，关键。

            }

        }
    }
</script>

<style>
    .chartClass {
    }
</style>